export default __webpack_public_path__ + "static/logo.augenaerztin-8e96fecec6e09b1fba108ec81569e544.png";